{
    "name": "ark.client",
    "version": "26.928.0",
    "scripts": {
        "ng": "ng",
        "prestart": "pnpm install",
        "start": "ng serve --port 4200 -o",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "test": "ng test"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^21.1.4",
        "@angular/common": "^21.1.4",
        "@angular/compiler": "^21.1.4",
        "@angular/core": "^21.1.4",
        "@angular/forms": "^21.1.4",
        "@angular/platform-browser": "^21.1.4",
        "@angular/platform-browser-dynamic": "^21.1.4",
        "@angular/router": "^21.1.4",
        "angular-froala-wysiwyg": "^4.2.0",
        "animate.css": "^4.1.1",
        "bootstrap": "^5.3.8",
        "breeze-client": "^2.1.5",
        "breeze-entity-generator": "^1.4.1",
        "devextreme": "25.2.5",
        "devextreme-angular": "25.2.5",
        "devextreme-schematics": "^1.6.9",
        "exceljs": "^4.4.0",
        "file-saver": "^2.0.5",
        "font-awesome": "^4.7.0",
        "froala-editor": "^4.7.1",
        "jquery": "^3.7.1",
        "jquery-slimscroll": "^1.3.8",
        "lodash": "^4.17.21",
        "metismenu": "^3.0.7",
        "moment": "^2.30.1",
        "ngx-bootstrap": "^20.0.0",
        "rxjs": "~7.8.1",
        "tslib": "^2.6.2",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^21.1.4",
        "@angular/cli": "^21.1.4",
        "@angular/compiler-cli": "^21.1.4",
        "@types/file-saver": "^2.0.7",
        "@types/jasmine": "~5.1.0",
        "devextreme-cli": "1.14.0",
        "devextreme-themebuilder": "25.2.5",
        "jasmine-core": "~5.1.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "typescript": "~5.9.3"
    }
}
